import React from "react";

export default React.createContext({
    handleLogout: () => {},
    handleSwitch: () => {},
    handleCheckBigBisoux: () => {},
    switchLogin: (type, id) => {},
    defaultCatalog: null
})
